import React from 'react';
import { Switch as RNSwitch } from 'react-native';
import useColors from 'hooks/useColors';
export const Switch = ({ style, ...props }) => {
    const colors = useColors();
    return (<RNSwitch {...props} activeThumbColor={colors.elements.white} activeTrackColor={colors.toggle.on} thumbColor={colors.elements.white} 
    // @ts-ignore
    trackColor={colors.toggle.off} style={style} testID={props.testID}/>);
};
